export default "__VITE_ASSET__CJ$BC4$P__"